import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Component that handles redirecting users landing on "/" to the dashboard.
 * Leaders used to be able to pick the leadership roadmap as their home page;
 * that preference was removed, so everyone lands on the main dashboard.
 */
const HomePageRedirect: React.FC = () => {
  return <Navigate to="/dashboard" replace />;
};

export default HomePageRedirect;
